const a = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNCAyM3YtMmgxVjFoMnYxaDE0LjEyNWwtMi45OTkgNiAzIDZIN3Y3aDF2Mkg0ek0xNy44OSA0SDd2OGgxMC44OWwtMi00IDItNHoiICBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=";
export {
  a as default
};
//# sourceMappingURL=flag-590945f6.mjs.map
